// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/ae5f47506cbb42cf040f.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"a4ec6ee5ae77bfa1b5a8","151":"1b5f75670c86b4229935","152":"9248716c6f2973caf024"}[chunkId] + ".chunk.js";
};